import { FormSchemaEntry } from '@gik/ui/Form';
import { RefObject } from 'react';

const ShippingFormSchema: (
  ref?: RefObject<HTMLElement>,
  emailReadOnly?: boolean,
  nameReadOnly?: boolean
) => FormSchemaEntry[] = (ref, emailReadOnly, nameReadOnly) => [
  {
    label: 'First name',
    name: 'firstName',
    type: nameReadOnly ? 'plaintext' : 'text',
    required: true,
    minLength: 2,
    maxLength: 255,
    props: { autoComplete: 'given-name', centerVertical: nameReadOnly },
  },
  {
    label: 'Last name',
    name: 'lastName',
    type: nameReadOnly ? 'plaintext' : 'text',
    required: true,
    minLength: 2,
    maxLength: 255,
    props: { autoComplete: 'family-name', centerVertical: nameReadOnly },
  },
  {
    label: 'Email address',
    name: 'email',
    type: emailReadOnly ? 'plaintext' : 'email',
    required: true,
    minLength: 2,
    maxLength: 255,
    props: {
      centerVertical: emailReadOnly,
    },
  },
  {
    label: 'Company name',
    name: 'companyName',
    type: 'text',
    optional: true,
    minLength: 2,
    maxLength: 255,
    props: { autoComplete: 'organization' },
  },
  {
    label: 'Country',
    name: 'country',
    type: 'plaintext',
    default: 'US',
    text: 'United States (US)',
    required: true,
    props: { autoComplete: 'country-name' },
  },
  {
    label: 'Street address',
    name: 'address1',
    type: 'text',
    required: true,
    minLength: 2,
    maxLength: 255,
    props: { placeholder: 'House number and street name', autoComplete: 'address-line1' },
  },
  {
    name: 'address2',
    type: 'text',
    required: false,
    minLength: 2,
    maxLength: 255,
    props: { placeholder: 'Apartment, suite, unit, etc (optional)', autoComplete: 'address-line2' },
  },
  {
    label: 'Town / City',
    name: 'city',
    type: 'text',
    required: true,
    minLength: 2,
    maxLength: 255,
    props: { autoComplete: 'address-level2' },
  },
  {
    label: 'State',
    name: 'state',
    type: 'select-us-states',
    required: true,
    props: {
      placeholder: 'State',
      autoComplete: 'address-level1',
      type: 'compact',
      isSearchable: true,
      scrollParent: ref,
    },
  },
  {
    label: 'Zip',
    name: 'postalCode',
    type: 'number',
    required: true,
    width: '90px',
    minLength: 5,
    // this max length is for validation
    maxLength: 5,
    // the max length in the props is to prevent more than 5 charaters to be used on the input
    props: { autoComplete: 'postal-code', maxLength: 5, maxLengthDisplay: false },
  },
];

export default ShippingFormSchema;
